import React from "react";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
} from "recharts";
import Styles from "../../styles/report/biohexagon.module.scss";

const Biometrichexagon = ({ report }) => {
  // Sort reports by block and map by block number
  const sortedReports = Array.isArray(report)
    ? [...report].sort(
        (a, b) =>
          (a?.block ?? Number.MAX_SAFE_INTEGER) -
          (b?.block ?? Number.MAX_SAFE_INTEGER)
      )
    : [];

  const reportsByBlock = new Map(
    sortedReports
      .filter((r) => Number.isFinite(r?.block))
      .map((r) => [r.block, r])
  );

  // Table: always 4 blocks; fill when data exists
  const biometricData = Array.from({ length: 4 }, (_, i) => {
    const block = i + 1;
    const r = reportsByBlock.get(block);
    return {
      block,
      bodyWeight: r?.body?.weight ?? "-",
      muscleGass: r?.body?.muscle ?? "-",
      bodyFat: r?.body?.fat ?? "-",
    };
  });

  // Helper to get exercise name from the first available block for that index
  const getExerciseName = (idx) => {
    for (let b = 1; b <= 4; b++) {
      const name = reportsByBlock.get(b)?.workouts?.[idx]?.workout?.name;
      if (name) return name;
    }
    return "";
  };

  // Chart: values per block number
  const radarData = Array.from({ length: 6 }, (_, idx) => ({
    exercise: getExerciseName(idx) || "",
    block1: reportsByBlock.get(1)?.workouts?.[idx]?.unifiedMetricScore,
    block2: reportsByBlock.get(2)?.workouts?.[idx]?.unifiedMetricScore,
    block3: reportsByBlock.get(3)?.workouts?.[idx]?.unifiedMetricScore,
    block4: reportsByBlock.get(4)?.workouts?.[idx]?.unifiedMetricScore,
  }));

  return (
    <div className={Styles.container}>
      {/* Biometric Report Table */}
      <div className={Styles.biometricSection}>
        <h2 className={Styles.sectionTitle}>Biometric Report</h2>

        <div className={Styles.tableContainer}>
          <div className={Styles.tableRow}>
            <div className={Styles.tableHeader}>Block</div>
            <div className={Styles.tableHeader}>Body Weight (kg)</div>
            <div className={Styles.tableHeader}>Muscle Mass (kg)</div>
            <div className={Styles.tableHeader}>Body Fat (%)</div>
          </div>

          {biometricData.map((row, index) => (
            <div key={index} className={Styles.tableRow}>
              <div className={Styles.tableCell}>{row.block}</div>
              <div className={Styles.tableCell}>{row.bodyWeight}</div>
              <div className={Styles.tableCell}>{row.muscleGass}</div>
              <div className={Styles.tableCell}>{row.bodyFat}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Category Name and Hexagon Chart */}
      <div className={Styles.categorySection}>
        <h2 className={Styles.sectionTitle}>Exercise Chart </h2>

        <div className={Styles.chartWrapper}>
          {/* Legend */}
          <div className={Styles.legend}>
            <div className={Styles.legendItem}>
              <div className={`${Styles.legendColor} ${Styles.gray}`}></div>
              <span className={Styles.legendText}>BLOCK 1</span>
            </div>
            <div className={Styles.legendItem}>
              <div
                className={`${Styles.legendColor} ${Styles.light_orange}`}
              ></div>
              <span className={Styles.legendText}>BLOCK 2</span>
            </div>
            <div className={Styles.legendItem}>
              <div className={`${Styles.legendColor} ${Styles.white}`}></div>
              <span className={Styles.legendText}>BLOCK 3</span>
            </div>
            <div className={Styles.legendItem}>
              <div
                className={`${Styles.legendColor} ${Styles.dark_orange}`}
              ></div>
              <span className={Styles.legendText}>BLOCK 4</span>
            </div>
          </div>

          {/* Hexagon Chart */}
          <div className={Styles.chartContainer}>
            <ResponsiveContainer width="100%" height={300}>
              <RadarChart
                data={radarData}
                margin={{ top: 20, right: 80, bottom: 20, left: 80 }}
              >
                <PolarGrid
                  gridType="polygon"
                  radialLines={true}
                  stroke="#555555"
                  strokeWidth={1}
                />
                <PolarAngleAxis
                  dataKey="exercise"
                  tick={{ fontSize: 11, fill: "#cccccc" }}
                />
                <Radar
                  name="Gray"
                  dataKey="block1"
                  stroke="#666666"
                  fill="#666666"
                  fillOpacity={0.5}
                  strokeWidth={1.5}
                />
                <Radar
                  name="lightOrange"
                  dataKey="block2"
                  stroke="#ff8c42"
                  fill="#ff8c42"
                  fillOpacity={0.7}
                  strokeWidth={1.5}
                />
                <Radar
                  name="White"
                  dataKey="block3"
                  stroke="#ffffff"
                  fill="#ffffff"
                  fillOpacity={0.3}
                  strokeWidth={1.5}
                />
                <Radar
                  name="darkOrange"
                  dataKey="block4"
                  stroke="#ff8c42"
                  fill="#ff8c42"
                  fillOpacity={0.6}
                  strokeWidth={1.5}
                />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Biometrichexagon;
